import Link from "next/link";
import React from "react";
import { useGlobalContext } from "@/context/globalContext";
import WhatsapPhoneBtn from "./WhatsapPhoneBtn";
import Image from "next/image";
import AnimatedIcon from "./AnimatedIcon";

const BottomBar = ({ ssr, RoutingTypeId, dataFooter, dataHeader }) => {
  const { mobileBar, setMobileBar } =
    useGlobalContext();

  const CloseAll = () => {
    setMobileBar(false);
  };
  return (
    <>
      <Link href="/" title={dataHeader?.Home?.title}>
        <div
          className="flex flex-col items-center justify-center text-center gap-y-1"
          onClick={() => {
            CloseAll();
          }}
        >
          <Image
            src="/villa vagonu mobile logo.webp"
            width={30}
            height={30}
            alt="logo"
            className="object-contain"
          />
          <span className="text-[0.625rem] font-medium leading-3">
            Anasayfa
          </span>
        </div>
      </Link>
      <div
        className="flex flex-col items-center justify-center text-center gap-y-1"
        onClick={() => {
          mobileBar == "search" ? CloseAll() : setMobileBar("search");
        }}
      >
        {mobileBar == "search" ? (
          <Image
            src="/closeBottom.svg"
            width={30}
            height={30}
            alt="icons"
            className="object-contain"
          />
        ) : (
          <Image
            src="/searchNew.svg"
            width={30}
            height={30}
            alt="icon"
            className="object-contain"
          />
        )}
        <span className="text-[0.625rem] font-medium leading-3">
          {mobileBar == "search" ? "Kapat" : "Arama Yap"}
        </span>
      </div>
      {RoutingTypeId == "ProductCategory" ||
      RoutingTypeId == "ProductDestination" ||
      RoutingTypeId == "ProductSearch" ||
      RoutingTypeId == "Home" ? (
        ssr.ShowTopSearchBar == "0" ? (
          <Link href={`/${ssr.All.url}`} title={ssr.All.title}>
            <div
              className={
                "text-sm flex  flex-col items-center justify-center text-center bg-primary rounded-full w-16 h-16 -mt-2 text-white shadow-md " +
                (mobileBar != "ProductSearch" ? "animate-bounce" : "")
              }
            >
              Tüm Villalar
            </div>
          </Link>
        ) : (
          <div
            className={
              "flex flex-col items-center justify-center gap-y-1" +
              (mobileBar != "ProductSearch" ? "" : "")
            }
            onClick={() => {
              mobileBar == "ProductSearch"
                ? CloseAll()
                : setMobileBar("ProductSearch");
            }}
          >
            {mobileBar == "ProductSearch" ? (
              <Image
                src="/closeBottom.svg"
                width={30}
                height={30}
                alt="icons"
                className="object-contain"
              />
            ) : (
              <>
                {/* <Image
                  src="/icons/calendar.gif"
                  width={34}
                  height={34}
                  alt="icons"
                  unoptimized
                  className="object-contain"
                /> */}
                {/* <Lottie
                  className="w-12 h-12"
                  animationData={groovyWalkAnimation}
                  loop={true}
                /> */}
                <AnimatedIcon />
              </>
            )}
            <span className="text-[0.625rem] font-medium leading-3">
              {mobileBar == "ProductSearch" ? "Kapat" : "Villa ara"}
            </span>
          </div>
        )
      ) : null}
      <WhatsapPhoneBtn
        ssr={ssr}
        dataFooter={dataFooter}
        RoutingTypeId={RoutingTypeId}
      />
    </>
  );
};

export default BottomBar;
